// extracted by mini-css-extract-plugin
export default {"menu":"GroupEditMenu_menu__PsguQ","MuiDrawerPaper":"GroupEditMenu_MuiDrawerPaper__V+LI4"};